const supportBlobSlice = window.Blob && (Blob.prototype.slice ||
    (Blob.prototype as any).webkitSlice || (Blob.prototype as any).mozSlice);

/**
 * Used to chunk file into smaller pieces for streaming
 * @param file - the file object
 * @param onChunk - when each chunk is formed
 * @param start - when starting the chunking process provides the total chunks
 * @param complete - handler for complete
 * @param error - handler for error
 * @param chunkSize in bytes
 */
export function chunkFile(file: File, onChunk: (startPosition: number, endPosition: number, fileBlob: Blob) => void, start: (fileSize: number, totalChunks: number) => void, complete?: () => void, error?: (e: Error) => void, chunkSize: number = 512 * 1024) {
    const fileSize   = file.size;
    const totalChunks = Math.ceil(fileSize / chunkSize);
    let chunkReaderBlock = null;
    let offset     = 0;

    chunkReaderBlock = (_offset, length, _file) => {
        if (supportBlobSlice) {
            const sliceFile = _file.mozSlice ? _file.mozSlice :
                _file.webkitSlice ? _file.webkitSlice :
                    _file.slice;
            try {
                const blob = sliceFile.call(file, _offset, length + _offset, file.type);
                onChunk(offset, Math.min(fileSize, chunkSize + offset), blob); // callback for handling read chunk
                offset += length;
                if (offset >= fileSize) {
                    if (complete) {
                        complete();
                    }
                } else {
                    chunkReaderBlock(offset, chunkSize, file);
                }
            } catch (e) {
                if (error) {
                    error(e);
                }
            }
        } else {
            onChunk(offset, fileSize, file); // legacy support if no blob slicing available
        }
    };

    start(fileSize, totalChunks);
    // now let's start the read with the first block
    chunkReaderBlock(offset, chunkSize, file);
}